var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "bg-control",
    d: "M9,.5H9A8.51,8.51,0,0,1,17.5,9h0A8.51,8.51,0,0,1,9,17.5H9A8.51,8.51,0,0,1,.5,9h0A8.51,8.51,0,0,1,9,.5Z",
    style: {
      fill: "#FFF"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,18a9,9,0,1,1,9-9A9,9,0,0,1,9,18ZM9,1a8,8,0,1,0,8,8A8,8,0,0,0,9,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadio);
export default __webpack_public_path__ + "static/media/icon-radio.a91410593970759f19110ec41ec21a96.svg";
export { ForwardRef as ReactComponent };